import React from "react";
import AllPicklists from "./_components/AllPicklists";

type Props = {
  setHeaderActions?: (node: React.ReactNode) => void;
  setHeaderButtons?: (node: React.ReactNode) => void;
};

export default function PickListPage({
  setHeaderActions,
  setHeaderButtons,
}: Props) {
  return (
    // <section className="min-h-[400px]">
      <AllPicklists
        setHeaderActions={setHeaderActions}
        setHeaderButtons={setHeaderButtons}
      />
    // </section>
  );
}
